<div class="administrators-panel-component-root">
  <div class="title">{{labels.administratorsList}}</div>
  <div class="advice" *ngIf="hasAdvice">
    <div *ngIf="!(regionalAdminService.voidRegions$ | async)" class="loading"></div>
    <div class="icon">
      <nb-icon icon="alert-circle-outline"></nb-icon>
    </div>
    <div class="warning">
      <div *ngIf="singleRegion" class="message single">{{ labels.regionWithoutRegional }}</div>
      <div *ngIf="!singleRegion" class="message multiple">{{ labels.regionsWithoutRegional }}</div>
      <span class="regions" *ngFor="let region of voidRegions; let i = index">
        {{region}}<ng-container *ngIf="!isLast(i)">, </ng-container>
      </span>
    </div>
  </div>
  <app-admin-list></app-admin-list>
</div>
